import { Link, useLocation } from 'react-router-dom';
import { Mail } from 'lucide-react';
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@/components/ui/card';

export function CheckEmail() {
  const location = useLocation();
  const email = (location.state as { email?: string } | null)?.email;

  return (
    <div className="flex min-h-screen items-center justify-center bg-cream px-4 py-12">
      <div className="w-full max-w-md">
        <Link
          to="/"
          className="mb-8 flex items-center justify-center gap-3 text-navy"
        >
          <img
            src="/brand/cpn_mark.svg"
            alt=""
            aria-hidden="true"
            className="h-10 w-10"
          />
          <span className="font-display text-base font-semibold">
            The Cambodian Professionals Network
          </span>
        </Link>
        <Card>
          <CardHeader>
            <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-gold/15 text-gold-dark">
              <Mail className="h-5 w-5" aria-hidden="true" />
            </div>
            <CardTitle className="mt-4">Check your email</CardTitle>
            <CardDescription>
              {email ? (
                <>
                  We sent a confirmation link to{' '}
                  <strong className="text-navy">{email}</strong>. Open it to
                  finish signing up.
                </>
              ) : (
                'We sent you a confirmation link. Open it to finish signing up.'
              )}
            </CardDescription>
          </CardHeader>
          <CardContent>
            <p className="text-sm text-muted">
              Didn't get it? Check spam, or{' '}
              <Link
                to="/signup"
                className="font-medium text-gold-dark hover:underline"
              >
                try again
              </Link>
              .
            </p>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
